export default __webpack_public_path__ + "static/media/Tureen.da581705.jpg";